(function ($, Drupal, once, drupalSettings) {
  'use strict';
  Drupal.behaviors.dlaParagraphTwoColTiles = {
    attach: function attach(context, settings) {
      var self = this;
      $(once('dla-processed', '.paragraph--type--columns-2-tiles .dla-field-tiles .layout .layout__grid > div', context)).each(function() {
        if ($(this).find('.paragraph--type--text').length > 0) {
          // To eliminate white gaps, make the parent element .layout__item take on the background color of its child element .paragraph--type--text
          let bgColor = $(this).find('.paragraph--type--text').css('background-color');
          $(this).closest('.layout__item').css('background-color', bgColor);
        }
      });

    }
  };

})(jQuery, Drupal, once, drupalSettings);
